import React from 'react';

interface EyebrowProps {
  children: React.ReactNode;
  /** Tracking scale — mirrors tailwind.config.js letterSpacing.eyebrow-*. Defaults to 'md' (0.2em), the most common section-kicker weight. */
  size?: 'sm' | 'md' | 'lg' | 'xl';
  /** Color tone for the surface it sits on. */
  tone?: 'default' | 'onDark' | 'footer';
  /** Prefixes a short accent rule — reserved for hero-level, once-per-page moments. */
  withRule?: boolean;
  className?: string;
}

const sizeStyles: Record<NonNullable<EyebrowProps['size']>, string> = {
  sm: 'text-[10px] tracking-eyebrow-sm',
  md: 'text-[11px] tracking-eyebrow',
  lg: 'text-[11px] tracking-eyebrow-lg',
  xl: 'text-[10px] tracking-eyebrow-xl',
};

const toneStyles: Record<NonNullable<EyebrowProps['tone']>, string> = {
  default: 'text-light-text-tertiary',
  onDark: 'text-white/60',
  footer: 'text-[#919191]',
};

export const Eyebrow: React.FC<EyebrowProps> = ({
  children,
  size = 'md',
  tone = 'default',
  withRule = false,
  className = '',
}) => {
  const label = (
    <p className={`uppercase ${sizeStyles[size]} ${toneStyles[tone]} ${className}`.trim()}>
      {children}
    </p>
  );

  if (!withRule) return label;

  return (
    <div className="flex items-center gap-4">
      <div className="w-8 h-px bg-brand-accent" />
      {label}
    </div>
  );
};
